module.exports = __webpack_public_path__ + "static/media/tour1.4c21915f.svg";